// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2n645","icon":"SortAdornment_icon__3Oq5J","up":"SortAdornment_up__4oEvt","down":"SortAdornment_down__2wm1v","active":"SortAdornment_active__1PHRS"};